<template>
    <main
        class="archivo-font-family"
        :id="routeName">
        <div>
            <!-- Your page content will inject here -->
            <slot />
        </div>
    </main>
</template>

<script setup>
    import favIcon from '../../src/assets/images/image/up-favicon.png';

    const router = useRouter();
    const routeName = computed(() => router.currentRoute.value.name);

    useHead({
        link: [
            {
                rel: 'icon',
                type: 'image/png',
                href: favIcon,
            },
            {
                rel: 'preload',
                href: '/assets/fonts/archivo/Archivo-700.woff2',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        ],
    });
</script>

<style scoped>
    .archivo-font-family {
        font-family: 'Archivo', sans-serif;
        font-optical-sizing: auto;
        font-style: normal;
    }
</style>
